import FooterLogo from "@/components/Footer/FooterLogo";
import tabBarMenuTabs from "@/data/nav/tabBarMenuTabs";
import {
  Copyright,
  FlexContainer,
  Footer,
  SocialMedia,
  TabBarMenu,
  useLanguage,
  useScreenWidth,
} from "@crescentapplications/react-ui";

export default function FooterContents() {
  const { language } = useLanguage();
  const { screenWidth, tabletBreakpoint } = useScreenWidth();

  return (
    <Footer>
      {screenWidth < tabletBreakpoint && screenWidth >= 280 ? (
        <TabBarMenu tabs={tabBarMenuTabs} />
      ) : (
        <FlexContainer direction="column" gap="lg">
          <FooterLogo />

          {/* ToDo: Change english facebook page if one is created */}
          <SocialMedia
            facebook={
              language === "ar"
                ? "https://www.facebook.com/AhmadElGamalAR"
                : "https://www.facebook.com/AhmadElGamalAR"
            }
            linkedIn="https://www.linkedin.com/in/ahmadelgamal"
            // x="AhmadElGamal"
            //   instagram="imamahmadelgamal"
            youtube="https://www.youtube.com/@ahmadelgamal"
            //   email="info@ahmadelgamal.com"
          />
          <Copyright />
        </FlexContainer>
      )}
    </Footer>
  );
}
